import DOMPurify from 'dompurify';
import * as Sentry from '@sentry/browser';
import {
	subMinutes,
	addMinutes,
	isValid,
	format as dateFormatter,
} from 'date-fns';

import { startSearch } from './filter.worker'; // eslint-disable-line import/no-webpack-loader-syntax

export const startSearchInstance = startSearch;

export const captureNSendError = error => {
	if (process.env.NODE_ENV === 'production') {
		Sentry.captureException(error);
	}
};

export const checkDocument = () =>
	typeof document !== 'undefined' && typeof window !== 'undefined';

export const Harpic = data => {
	if (checkDocument()) {
		return `${DOMPurify.sanitize(data)}`;
	}
	return data;
};

export const requestIdleCb = (cb, timeout) => {
	if (checkDocument()) {
		if (typeof window.requestIdleCallback !== 'undefined') {
			const tout = timeout ? { timeout } : {};
			requestIdleCallback(cb, tout);
		} else if (typeof window.requestAnimationFrame !== 'undefined') {
			requestAnimationFrame(cb);
		} else {
			setTimeout(cb, 16);
		}
	} else {
		cb();
	}
};

export const myRand = () => parseInt(Math.random() * 999999999999999);

export const concatArrays = (a, b) =>
	a.concat(b.filter(item => a.indexOf(item) < 0));

export const concatArrays2 = function (...args) {
	const hash = {};
	const arr = [];
	for (let i = 0; i < args.length; i++) {
		for (let j = 0; j < args[i].length; j++) {
			if (hash[args[i][j]] !== true) {
				arr[arr.length] = args[i][j];
				hash[args[i][j]] = true;
			}
		}
	}
	return arr;
};

export const fileInputChecker = (el, extensions, size) =>
	extensions.some(ext => el.type.match(ext) && el.size < size);

export const GetURLParams = () => ({
	fallbackGetUrlParameter(param) {
		if (checkDocument()) {
			const name = param.replace(/[[]/, '\\[').replace(/[\]]/, '\\]');
			const regex = new RegExp(`[\\?&]${name}=([^&#]*)`);
			const results = regex.exec(window.location.search);
			return results === null
				? null
				: decodeURIComponent(results[1].replace(/\+/g, ' '));
		}

		return null;
	},
	getParams(value) {
		if (typeof URLSearchParams === 'undefined') {
			return this.fallbackGetUrlParameter(value);
		}
		return checkDocument()
			? new URLSearchParams(window.location.search).get(value)
			: null;
	},
});

export const userAgent = checkDocument()
	? navigator.userAgent || navigator.vendor || window.opera
	: null;

export const getMobileOperatingSystem = () => {
	if (checkDocument()) {
		if (
			userAgent.match(/iPad/i) ||
			userAgent.match(/iPhone/i) ||
			userAgent.match(/iPod/i)
		) {
			return 'iOS';
		}
		if (userAgent.match(/Android/i)) {
			return 'Android';
		}
		if (userAgent.match(/Windows Phone/i)) {
			return 'bhindoj';
		}
	}

	return false;
};

export const getBrowserNVersion = () => {
	if (checkDocument()) {
		const sayswho = (() => {
			const ua = navigator.userAgent;
			let tem;
			let M =
				ua.match(
					/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i
				) || [];
			if (/trident/i.test(M[1])) {
				tem = /\brv[ :]+(\d+)/g.exec(ua) || [];
				return 'IE ' + (tem[1] || '');
			}
			if (M[1] === 'Chrome') {
				tem = ua.match(/\b(OPR|Edge)\/(\d+)/);
				if (tem != null) {
					return tem.slice(1).join(' ').replace('OPR', 'Opera');
				}
			}
			M = M[2]
				? [M[1], M[2]]
				: [navigator.appName, navigator.appVersion, '-?'];
			if ((tem = ua.match(/version\/(\d+)/i)) != null) {
				M.splice(1, 1, tem[1]);
			}
			return M.join(' ');
		})();

		return sayswho;
	}
	return null;
};

/* <![CDATA[ */
export const goog_snippet_vars = function () {
	if (checkDocument()) {
		const w = window;
		w.google_conversion_id = 822916478;
		w.google_conversion_label = 'WC-KCJvgv30Q_uqyiAM';
		w.google_conversion_value = 10.0;
		w.google_conversion_currency = 'INR';
		w.google_remarketing_only = false;
	}
};
// DO NOT CHANGE THE CODE BELOW.
export const goog_report_conversion = function (url) {
	if (checkDocument()) {
		goog_snippet_vars();
		window.google_conversion_format = '3';
		const opt = {};
		opt.onload_callback = function () {
			if (typeof url !== 'undefined') {
				window.location = url;
			}
		};
		const conv_handler = window.google_trackConversion;
		if (typeof conv_handler === 'function') {
			conv_handler(opt);
		}
	}
};
/* ]]> */

const CookieControl = () => ({
	createNew(name, value, days) {
		let expires = '';
		if (days) {
			const date = new Date();
			date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
			expires = `; expires=${date.toGMTString()}`;
		}
		if (checkDocument()) {
			document.cookie = `${name}=${value}${expires}; path=/; domain=.bitbns.com;secure`;
		}
	},

	check(name) {
		const nameEQ = `${name}=`;
		const ca = (checkDocument() && document.cookie.split(';')) || '';
		for (let i = 0; i < ca.length; i++) {
			const c = ca[i].trim();
			if (c.indexOf(nameEQ) === 0) {
				return c.substring(nameEQ.length, c.length);
			}
		}
		return null;
	},

	remove(name) {
		this.createNew(name, '', -1);
	},
});

export const kukeej = CookieControl();

/* ***************** new addition 1- event delegation ************ */

const isSame =
	checkDocument() && document.body.isEqualNode ? 'isEqualNode' : 'isSameNode';

export const delegateClass = (
	wrapperEl,
	eventName,
	delegatedElClass,
	action
) => {
	eventName.split(' ').forEach(en => {
		wrapperEl.addEventListener(en, event => {
			let checkingNode = event.target;
			while (checkingNode) {
				if (checkingNode[isSame](wrapperEl)) {
					// checking element itself
					checkingNode = undefined; // STOP loop
				} else if (checkingNode.classList.contains(delegatedElClass)) {
					// found delegated element
					action.call(checkingNode, event); // "this" will be delegated el
					checkingNode = undefined; // STOP loop
				} else {
					// going to parent node
					checkingNode = checkingNode.parentNode;
				}
			}
		});
	});
};

// export class imgObserver {
// 	constructor() {
// 		this.imgIObserver = false;
// 	}
// 	observe(image, source, action) {
// 		if (checkDocument()) {
// 			if ('IntersectionObserver' in window) {
// 				this.imgIObserver = new IntersectionObserver(
// 					entries => {
// 						entries.forEach(entry => {
// 							if (entry.isIntersecting) {
// 								// Stop watching and load the image
// 								this.imgIObserver.unobserve(entry.target);
// 								action();
// 								// entry.target.classList.add('c-lazyload--complete');
// 							}
// 						});
// 					},
// 					{
// 						rootMargin: '50px',
// 						threshold: 0.001,
// 					}
// 				);
// 			}
// 		}
// 		if (!this.imgIObserver) {
// 			image.src = source;
// 		} else {
// 			this.imgIObserver.observe(image);
// 		}
// 		return this.imgIObserver;
// 	}
// 	disconnect() {
// 		this.imgIObserver.disconnect();
// 	}
// }

// export const imgObserver = (image, source, action, rootSelector) => {
// 	let imgIObserver = false;
// 	if (checkDocument()) {
// 		if ('IntersectionObserver' in window) {
// 			imgIObserver = new IntersectionObserver(
// 				entries => {
// 					entries.forEach(entry => {
// 						if (entry.isIntersecting) {
// 							// Stop watching and load the image
// 							imgIObserver.unobserve(entry.target);
// 							action();
// 							// entry.target.classList.add('c-lazyload--complete');
// 						}
// 					});
// 				},
// 				{
// 					root:
// 						(rootSelector &&
// 							document.querySelector(rootSelector)) ||
// 						null,
// 					rootMargin: '50px',
// 					threshold: 0.001,
// 				}
// 			);
// 		}
// 	}
// 	if (!imgIObserver) {
// 		image.src = source;
// 	} else {
// 		imgIObserver.observe(image);
// 	}
// 	return imgIObserver;
// };

export const dateFromString = str => {
	const a = str.split(/[^0-9]/).map(s => parseInt(s, 10));

	return new Date(
		a[0],
		a[1] - 1 || 0,
		a[2] || 1,
		a[3] || 0,
		a[4] || 0,
		a[5] || 0,
		a[6] || 0
	);
};

export const getScrollbarWidth = (() => {
	let memoWidth = null;

	return () => {
		if (checkDocument()) {
			if (memoWidth !== null) {
				return memoWidth;
			}

			const scrollDiv = document.createElement('div');
			scrollDiv.className = 'scrollbar-measure';
			document.body.appendChild(scrollDiv);

			// Get the scrollbar width
			memoWidth = scrollDiv.offsetWidth - scrollDiv.clientWidth;
			document.body.removeChild(scrollDiv);
			return memoWidth; // Mac:  151 the DIV
		}
		return 0;
	};
})();

export const openNewLink = url => {
	if (checkDocument()) {
		window.location.href = url;
	}
};

export const getWhichDay = (year, month, whichDay) => {
	const date = new Date(year, month, 1, 0, 0, 0, 0);
	date.setDate(whichDay - date.getDay());
	return date;
};

export const comeToPapa = (el, type = 'v') => {
	let opts = {};
	if (type === 'h') {
		opts = {
			behavior: 'smooth',
			block: 'nearest',
			inline: 'center',
		};
	}
	if (type === 'b') {
		opts = {
			behavior: 'smooth',
			block: 'center',
			inline: 'center',
		};
	}
	if (type === 'v') {
		opts = {
			behavior: 'smooth',
			inline: 'nearest',
			block: 'center',
		};
	}
	requestAnimationFrame(() => {
		el.scrollIntoView(opts);
	});
};

export const comeToView = (el, type = 'h') => {
	const p = el.parentElement; // parent
	const pRect = p.getBoundingClientRect();
	const pRight = pRect.left + pRect.width;

	const elRect = el.getBoundingClientRect();
	const elRight = elRect.left + elRect.width;

	const pBottom = pRect.top + pRect.height;

	const elBottom = elRect.top + elRect.height;

	switch (type) {
		case 'h':
			if (elRect.x < pRect.left) {
				requestAnimationFrame(() => {
					p.scrollLeft = el.offsetLeft;
				});
			} else if (elRight > pRight) {
				requestAnimationFrame(() => {
					p.scrollLeft = el.offsetLeft - pRect.width + elRect.width;
				});
			}

			return;
		default:
			if (elRect.y < pRect.top) {
				requestAnimationFrame(() => {
					p.scrollTop = el.offsetTop;
				});
			} else if (elBottom > pBottom) {
				requestAnimationFrame(() => {
					p.scrollTop = el.offsetTop - pRect.height + elRect.height;
				});
			}
			return;
	}
};

const getMid = el =>
	el.offsetTop + (el.offsetParent ? getMid(el.offsetParent) : 0);

export const bringToMid = el => {
	const top = getMid(el) - window.innerHeight / 2;
	window.scrollTo(0, top);
};

export const scientificToDecimal = val => {
	let num = val;
	// if the number is in scientific notation remove it
	if (/\d+\.?\d*e[+-]*\d+/i.test(num)) {
		const zero = '0';
		const parts = String(num).toLowerCase().split('e'); // split into coeff and exponent
		const e = parts.pop(); // store the exponential part
		let l = Math.abs(e); // get the number of zeros
		const sign = e / l;
		const coeff_array = parts[0].split('.');

		if (sign === -1) {
			num = zero + '.' + new Array(l).join(zero) + coeff_array.join('');
		} else {
			const dec = coeff_array[1];
			if (dec) {
				l = l - dec.length;
			}
			num = coeff_array.join('') + new Array(l + 1).join(zero);
		}
	}

	return num;
};

export const decimalTrimmer2 = (val, floatPlaces = 2) => {
	const re = new RegExp('^-?\\d*(?:.\\d{0,' + (floatPlaces || -1) + '})?');
	const newVal = scientificToDecimal(val);

	return newVal.toString().match(re)
		? newVal.toString().match(re)[0]
		: newVal;
};

export const decimalTrimmer = (val, floatPlaces = 2) => {
	if (val === '') {
		return '';
	}
	const tens = 10 ** floatPlaces;
	return Math.floor(val * tens) / tens;
};

export const TabFocusCheck = () => {
	const keys = {
		hidden: 'visibilitychange',
		mozHidden: 'mozvisibilitychange',
		msHidden: 'msvisibilitychange',
		webkitHidden: 'webkitvisibilitychange',
	};
	let visStateKey = null;
	let visEventKey = null;

	if (checkDocument()) {
		visStateKey = Object.keys(keys).find(key => key in document);
		visEventKey = keys[visStateKey];
	}

	return {
		getVisStateKey: () => visStateKey,
		tabFocus: fn => {
			if (checkDocument()) {
				if (fn) {
					document.addEventListener(visEventKey, fn, false);
				}
				return !document[visStateKey];
			}
			return null;
		},
		removeFocusEvent: fn => {
			if (checkDocument()) {
				document.removeEventListener(visEventKey, fn, false);
			}
		},
	};
};

const checkOnlineStatus = () => {
	const onlineFns = [];
	const offlineFns = [];

	return {
		onOnline: fn => {
			if (checkDocument()) {
				const newFn = ({ type }) => {
					if (typeof fn === 'function') {
						fn(type);
					}
				};

				window.addEventListener('online', newFn);
				onlineFns.push(newFn);
			}
		},
		onOffline: fn => {
			if (checkDocument()) {
				const newFn = ({ type }) => {
					if (typeof fn === 'function') {
						fn(type);
					}
				};

				window.addEventListener('offline', newFn);
				onlineFns.push(newFn);
			}
		},
		resetAll: () => {
			onlineFns.forEach(fn => {
				window.removeEventListener('online', fn);
			});
			offlineFns.forEach(fn => {
				window.removeEventListener('offline', fn);
			});
		},
	};
};

export const onlineStatusInstance = checkOnlineStatus();

export const getWSLSKey = key => {
	if (checkDocument()) {
		const value = window.localStorage.getItem(key);
		if (value !== null) {
			try {
				return JSON.parse(Harpic(decodeURIComponent(value)));
			} catch (err) {
				console.log(err);

				return Harpic(value);
			}
		}
	}
	return '';
};

export const setWSLSKey = (key, val) => {
	if (checkDocument()) {
		window.localStorage.setItem(
			key,
			typeof val === 'string' || typeof val === 'number'
				? val
				: encodeURIComponent(JSON.stringify(val))
		);
		return true;
	}
	return false;
};

export const cleanLSSimilarKey = (text, LSKeys) => {
	if (checkDocument()) {
		let newLSKeys;

		if (typeof LSKeys === 'string') {
			newLSKeys = LSKeys.split(',').join('|');
		} else {
			newLSKeys = LSKeys.join('|');
		}
		const matchRegex = new RegExp(`^(${newLSKeys})$`);

		Object.keys(window.localStorage).forEach(key => {
			if (key.startsWith(text) && !key.match(matchRegex)) {
				window.localStorage.removeItem(key);
			}
		});
	}
};

export const getLSSimilarKey = (text, LSCurrent) => {
	let latestMatch = null;
	if (checkDocument()) {
		if (typeof LSCurrent === 'string') {
			LSCurrent = LSCurrent.split(',').join('|');
		} else {
			LSCurrent = LSCurrent.join('|');
		}
		const matchRegex = new RegExp(`^(${LSCurrent})$`);

		Object.keys(window.localStorage).forEach(key => {
			if (key.startsWith(text) && !key.match(matchRegex)) {
				const datePart = key.split('~')[1];
				if (new Date(datePart) > new Date(latestMatch)) {
					latestMatch = datePart;
				}
			}
		});
	}
	return latestMatch;
};

export const docReady = fn => {
	if (checkDocument()) {
		if (
			document.attachEvent
				? document.readyState === 'complete'
				: document.readyState !== 'loading'
		) {
			fn();
		} else {
			document.addEventListener('DOMContentLoaded', fn);
		}
	}
};

const whichTransitionEndEvent = () => {
	if (checkDocument()) {
		const el = document.createElement('fakeelement');
		const transitions = {
			transition: 'transitionend',
			OTransition: 'oTransitionEnd',
			MozTransition: 'transitionend',
			WebkitTransition: 'webkitTransitionEnd',
		};

		return transitions[
			Object.keys(transitions).find(t => el.style[t] !== undefined)
		];
	}

	return false;
};

export const getTransitionEndEvent = whichTransitionEndEvent();

const whichAnimationEndEvent = () => {
	if (checkDocument()) {
		const el = document.createElement('fakeelement');
		const animations = {
			animation: 'animationend',
			OAnimation: 'oAnimationEnd',
			MozAnimation: 'animationend',
			WebkitAnimation: 'webkitAnimationEnd',
		};

		return animations[
			Object.keys(animations).find(t => el.style[t] !== undefined)
		];
	}
	return false;
};

export const getAnimationEndEvent = whichAnimationEndEvent();

export const waitMaadi = ms => new Promise(r => setTimeout(r, ms));

export const postFetch = (url, params, type) =>
	fetch(url, {
		method: 'POST',
		body: params,
		headers: new Headers({
			'Content-Type':
				type === 'json'
					? 'application/json'
					: 'application/x-www-form-urlencoded',
			'Cache-Control': 'no-cache',
			Pragma: 'no-cache',
		}),
		credentials: 'include',
		cache: 'no-cache',
	})
		.then(
			response => {
				if (!response.ok) {
					console.log('Happy Diwali! API phat gayi:', url);
					return [{ status: 0, msg: 'Something went wrong.' }];
				}
				return response.json();
			},
			error => {
				console.log('Kuch to gadbad hai daya:', url, error);
				captureNSendError(error);
				return [{ status: 0, msg: 'Something went wrong.' }];
			}
		)
		.then(json => json[0])
		.catch(error => {
			console.log('Kuch to gadbad hai daya:', url, error);
			captureNSendError(error);
			return [{ status: 0, msg: 'Something went wrong.' }];
		});

export const getFetch = (url, params) =>
	fetch(`${url}${params ? `?${params}` : ''}`, {
		method: 'GET',
		credentials: 'include',
		cache: 'no-cache',
		headers: new Headers({
			'Cache-Control': 'no-cache',
			Pragma: 'no-cache',
		}),
	})
		.then(
			response => {
				if (!response.ok) {
					console.log('Happy Diwali! API phat gayi:', url);
					return [{ status: 0, msg: 'Something went wrong.' }];
				}
				return response.json();
			},
			error => {
				console.log('Kuch to gadbad hai daya:', url, error);
				captureNSendError(error);
				return [{ status: 0, msg: 'Something went wrong.' }];
			}
		)
		.then(json => json[0])
		.catch(error => {
			console.log('Kuch to gadbad hai daya:', url, error);
			captureNSendError(error);
			return [{ status: 0, msg: 'Something went wrong.' }];
		});

export const hasOwn = (obj, prop) =>
	Object.prototype.hasOwnProperty.call(obj, prop);

export function debounce(func, wait, immediate) {
	let timeout;
	return function () {
		const context = this,
			args = arguments;
		const later = function () {
			timeout = null;
			if (!immediate) {
				func.apply(context, args);
			}
		};
		const callNow = immediate && !timeout;
		clearTimeout(timeout);
		timeout = setTimeout(later, wait);
		if (callNow) {
			func.apply(context, args);
		}
	};
}

export const inrConverter = (value, min, max) => {
	let number;

	if (!value || Number.isNaN(value)) {
		number = '0';
	} else {
		number = value.toString();
	}

	const shortNumber = decimalTrimmer2(number, min);

	if (max) {
		number = decimalTrimmer2(number, max);
		if (number === shortNumber) {
			number = shortNumber;
		}
	} else {
		number = shortNumber;
	}
	number = number.toString();

	let afterPoint = '';
	if (number.indexOf('.') > 0) {
		afterPoint = number.substring(number.indexOf('.'), number.length);
		if (afterPoint.length - 1 < min) {
			afterPoint = afterPoint + '0'.repeat(min - (afterPoint.length - 1));
		}
	} else {
		if (min > 0) {
			afterPoint = '.' + '0'.repeat(min);
		}
	}
	number = Math.floor(number);
	number = number.toString();
	let lastThree = number.substring(number.length - 3);
	const otherNumbers = number.substring(0, number.length - 3);
	if (otherNumbers !== '') {
		lastThree = ',' + lastThree;
	}
	const res =
		otherNumbers.replace(/\B(?=(\d{2})+(?!\d))/g, ',') +
		lastThree +
		afterPoint;

	return res;
};

export const intNumberConverter = (value, min, max, type = 2) => {
	let number;

	if (!value || Number.isNaN(value)) {
		number = '0';
	} else {
		number = value.toString();
	}

	const shortNumber = decimalTrimmer2(number, min);

	if (max) {
		number = decimalTrimmer2(number, max);
		if (number === shortNumber) {
			number = shortNumber;
		}
	} else {
		number = shortNumber;
	}
	number = number.toString();

	let afterPoint = '';
	if (number.indexOf('.') > 0) {
		afterPoint = number.substring(number.indexOf('.'), number.length);
		if (afterPoint.length - 1 < min) {
			afterPoint = afterPoint + '0'.repeat(min - (afterPoint.length - 1));
		}
	} else if (min > 0) {
		afterPoint = '.' + '0'.repeat(min);
	}
	number = Math.floor(number);
	number = number.toString();
	let lastThree = number.substring(number.length - 3);
	const otherNumbers = number.substring(0, number.length - 3);
	if (otherNumbers !== '') {
		lastThree = ',' + lastThree;
	}
	const res =
		otherNumbers.replace(
			new RegExp(`\\B(?=(\\d{${type}})+(?!\\d))`, 'g'),
			','
		) +
		lastThree +
		afterPoint;

	return res;
};

export const moneyFormatter = (
	val,
	options = {
		minimumFractionDigits: 0,
		maximumFractionDigits: 2,
	},
	locale = 'en-IN'
) => {
	const {
		minimumFractionDigits: min = 0,
		maximumFractionDigits: max = Math.max(min, 2),
	} = options;

	if (locale === 'en-IN') {
		return intNumberConverter(val, min, max, 2);
	}
	if (locale === 'en-US') {
		return intNumberConverter(val, min, max, 3);
	}
	return !!val ? val.toLocaleString(locale, options) : 0;
};

export const compareVersion = (v1, v2) => {
	if (typeof v1 !== 'string') return false;
	if (typeof v2 !== 'string') return false;
	v1 = v1.split('.');
	v2 = v2.split('.');

	const k = Math.min(v1.length, v2.length);

	for (let i = 0; i < k; ++i) {
		v1[i] = parseInt(v1[i], 10);
		v2[i] = parseInt(v2[i], 10);
		if (v1[i] > v2[i]) return 1;
		if (v1[i] < v2[i]) return -1;
	}
	return v1.length === v2.length ? 0 : v1.length < v2.length ? -1 : 1;
};

export const hardReload = type => {
	if (checkDocument()) {
		if (type === 1) {
			window.location.reload();
		} else {
			window.location.reload(true);
		}
	}
};

export const generateQrCode = (val, size = 120) =>
	`https://chart.googleapis.com/chart?cht=qr&chs=${size}x${size}&chld=L|0&chl=${val}`;
// `https://api.qrserver.com/v1/create-qr-code/?size=${size}x${size}&margin=0&data=${val}`;

export const removeDelegateClass = (
	wrapperEl,
	eventName,
	delegatedElClass,
	action
) => {
	eventName.split(' ').forEach(en => {
		wrapperEl.removeEventListener(en, event => {
			let checkingNode = event.target;
			while (checkingNode) {
				if (checkingNode[isSame](wrapperEl)) {
					// checking element itself
					checkingNode = undefined; // STOP loop
				} else if (checkingNode.classList.contains(delegatedElClass)) {
					// found delegated element
					action.call(checkingNode, event); // "this" will be delegated el
					checkingNode = undefined; // STOP loop
				} else {
					// going to parent node
					checkingNode = checkingNode.parentNode;
				}
			}
		});
	});
};

export const asyncForEach = async (array, callback) => {
	/**
	 * @description: https://codeburst.io/javascript-async-await-with-foreach-b6ba62bbf404
	 */

	for (let index = 0; index < array.length; index++) {
		await callback(array[index], index, array);
	}
};

export const memoized =
	func =>
	(...args) => {
		func.cache = func.cache || {};

		return func.cache[args] || (func.cache[args] = func.apply(this, args));
	};

export const checkShareAvailable =
	checkDocument() && typeof navigator.share !== 'undefined';

export const getShareIntent = async (title, text, url) => {
	const returnMsg = {
		type: -1,
		msg: "Didn't Share",
	};

	if (checkShareAvailable) {
		await navigator
			.share({
				title,
				text,
				url,
			})
			.then(() => {
				returnMsg.type = 1;
				returnMsg.msg = 'Successfully Shared';
			})
			.catch(error => {
				returnMsg.type = 0;
				returnMsg.msg = error;
			});
	}

	return returnMsg;
};

export const smoothAnimate = (fn, init, final, start, time, oneEnd) => {
	let rafVal = null;

	if (checkDocument && hasOwn(window, 'requestAnimationFrame')) {
		const rafFn = (curr = start) => {
			if (
				(final > init && curr < final) ||
				(final < init && curr > final)
			) {
				rafVal = requestAnimationFrame(() => {
					fn(curr);
					const newCurr = curr + (final - init) / (time * 60);
					rafFn(newCurr);
				});
			}
			if (
				typeof oneEnd === 'function' &&
				((final > init && curr >= final) ||
					(final < init && curr <= final))
			) {
				requestAnimationFrame(() => {
					oneEnd();
				});
			}
		};

		rafFn();
	} else {
		fn(final);
	}

	return {
		getRafVal: () => rafVal,
	};
};

export const anythingObserver = (
	onNonIntersect = () => {},
	onIntersect,
	onNoIO = () => {},
	selectorElem,
	watchingWrapper,
	rootMargin = '50px',
	threshold = 0.001,
	unobserveOnIntersect,
	disconnectOnIntersect
) => {
	let ioObserver = false;

	if (checkDocument()) {
		if ('IntersectionObserver' in window) {
			ioObserver = new IntersectionObserver(
				entries => {
					entries.forEach(entry => {
						if (entry.isIntersecting) {
							// Stop watching and load the image
							if (unobserveOnIntersect) {
								ioObserver.unobserve(entry.target);
							}
							onIntersect();
							if (disconnectOnIntersect) {
								ioObserver.disconnect();
							}
							// entry.target.classList.add('c-lazyload--complete');
						} else {
							onNonIntersect();
						}
					});
				},
				{
					root: watchingWrapper || null,
					rootMargin,
					threshold,
				}
			);
		}
	}

	if (!ioObserver) {
		onNoIO();
	} else {
		ioObserver.observe(selectorElem);
	}

	return {
		observerVal: ioObserver,
		destroy: () => {
			if (ioObserver && typeof ioObserver.disconnect !== 'undefined') {
				ioObserver.disconnect();
			}
		},
	};
};

export const imgObserver = (image, rootSelector, action) =>
	anythingObserver(
		undefined, // onNonIntersect = () => {},
		action, // onIntersect,
		action, // onNoIO = () => {},
		image, // selectorElem,
		document.querySelector(rootSelector), // watchingWrapper,
		undefined, // rootMargin = '50px',
		undefined, // threshold = 0.001,
		true, // unobserveOnIntersect,
		true // disconnectOnIntersect
	);

export const camelToSentence = (text = '') => {
	if (typeof text !== 'string') {
		return text;
	}

	const pos = [0];
	let word = '';

	text.split('').forEach((ch, index) => {
		if (ch === ch.toUpperCase()) {
			pos.push(index);
		}
	});
	pos.forEach((p, index) => {
		const nextPos = index + 1 === pos.length ? text.length : pos[index + 1];

		word = `${word} ${text.slice(p, nextPos)}`;
	});

	return word.trim();
};

export const dateFormat = (time, format, offset = 330) => {
	const date =
		offset < 0
			? subMinutes(new Date(time), Math.abs(offset))
			: addMinutes(new Date(time), Math.abs(offset));

	if (isValid(date)) {
		return dateFormatter(date, format);
	}
	return '—';
};
